// extracted by mini-css-extract-plugin
export default {"text":"Tittle_text__yVgqc","border":"Tittle_border__E10ZI","tittle":"Tittle_tittle__-5zLa"};